import React from "react";
import * as moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import {
  appendDeletionArray,
  subtractDeletionArray,
  changeTemplatesModal,
  setActiveTemplateDeletion,
  setActiveTemplateDisplay,
} from "../../../../../../redux/actions/templates";
import {
  ChangeIconButton,
  DeleteIconButton,
} from "../../../../../library/button";
import { Link } from "react-router-dom";
import { Checkbox } from "../../../../../library/checkbox";

const Index = ({ singleTemplate, index, arr }) => {
  const dispatch = useDispatch();
  const deletions = useSelector((state) => state.templates.deletionArray);

  const activeCompany = useSelector(
    (state) => state.activeCompany && state.activeCompany.activeCompany
  );

  const determineSettingsHoverButton = () => {
    if (!activeCompany) {
      return "Du må velge et selskap før du kan utføre denne handlingen.";
    }

    if (activeCompany && !activeCompany.subscription) {
      return "Du må ha et aktivt abonnement for å kunne gjøre dette.";
    }
  };

  const clickDeleteSingleTemplate = (key, type) => {
    if (activeCompany.subscription) {
      dispatch(changeTemplatesModal({ deleteModal: true }));
      dispatch(setActiveTemplateDeletion({ id: key, type: type }));
    }
  };

  const handleSingleSelection = (e, id) => {
    if (e.target.checked) {
      if (!deletions.includes(id)) {
        dispatch(appendDeletionArray(id));
      }
    } else {
      if (deletions.includes(id)) {
        dispatch(subtractDeletionArray(id));
      }
    }
  };

  const determineSettingsDeleteButton = () => {
    if (!activeCompany) {
      return "Du må velge et selskap før du kan utføre denne handlingen.";
    }

    if (activeCompany && !activeCompany.subscription) {
      return "Du må ha et aktivt abonnement for å kunne gjøre dette.";
    }
  };

  const clickViewTemplate = () => {
    dispatch(changeTemplatesModal({ viewModal: true }));
    dispatch(
      setActiveTemplateDisplay({
        id: singleTemplate.id,
        type: singleTemplate.type,
        title: singleTemplate.title,
        html: singleTemplate.html,
      })
    );
  };

  return (
    <tr key={singleTemplate.id} className={index === arr.length - 1 && "last"}>
      <td>
        <Checkbox
          key={singleTemplate.key}
          templateId={singleTemplate.id}
          name="templateId"
          onChange={(e) => handleSingleSelection(e, singleTemplate.id)}
          checked={deletions.includes(singleTemplate.id) ? true : false}
          type="checkbox"
          id="select"
        />
      </td>
      <td onClick={() => clickViewTemplate()}>
        <span className="template-title">{singleTemplate.title}</span>
      </td>
      <td onClick={() => clickViewTemplate()}>{singleTemplate.addedBy}</td>
      <td onClick={() => clickViewTemplate()}>
        {moment.unix(singleTemplate.lastUpdated).format("HH:MM DD/MM/YYYY")}
      </td>
      <td onClick={() => clickViewTemplate()}>
        {moment.unix(singleTemplate.timestamp).format("HH:MM DD/MM/YYYY")}
      </td>
      <td>
        <Link to={`/dashboard/mal/${singleTemplate.id}`}>
          <ChangeIconButton data-tip={determineSettingsHoverButton()} />
        </Link>
        <DeleteIconButton
          data-tip={determineSettingsDeleteButton()}
          onClick={() =>
            clickDeleteSingleTemplate(singleTemplate.id, singleTemplate.type)
          }
        />
      </td>
    </tr>
  );
};

export default Index;
